export default class EventListenerHelper {
  /**
   * @param { { callback: Function, name: string }[] } listeners
   * @param { any } [element=document]
   */
  static setUpEventListeners(listeners, element = document) {
    for(const listener of listeners) {
      element.addEventListener(listener.name, listener.callback);
    }
  }

  /**
   * @param { { callback: Function, name: string }[] } listeners
   * @param { any } [element=document]
   */
  static teardownEventListeners(listeners, element = document) {
    for(const listener of listeners) {
      element.removeEventListener(listener.name, listener.callback);
    }
  }
}
